<template>
  <b-container>
    <h4>Name</h4>
    <b-form-input
        id="input-1"
        v-model="section.name"
        required
    ></b-form-input>
    <hr class="mt-4 mb-4">
    <h4>Inhalt</h4>
    <trumbowyg v-if="section.type === 'wysiwyg'" v-model="section.content" :config="config"/>
    <Slider v-if="section.type === 'slider'" :slider="section.content"/>
    <Files v-if="section.type === 'files'" :files="section.content"/>
    <hr class="mt-4 mb-4">
    <b-button variant="outline-success" @click="storeSection(section)" block>Speichern</b-button>
  </b-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import Slider from "@/components/Article/Slider";
import Files from "./Files";
import 'jquery-resizable-dom';
import '@/trumbowyg.multiupload';
import '@/trumbowyg.table';
import '@/trumbowyg.fontsize'
import '@/trumbowyg.resizimg';

export default {
  name: "SectionEdit",
  components: {Slider, Files},
  data() {
    return {
      sectionId: parseInt(this.$route.params.sectionId),
      config: {
        tagsToRemove: ['script'],
        lang: 'de',
        imageWidthModalEdit: true,
        disabled() {
          return this.article === undefined;
        },
        btns: [
          ['formatting', 'fontsize', 'horizontalRule'],
          ['strong', 'em', 'del', 'removeformat'],
          ['link', 'multiupload', 'table'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['fullscreen'],
        ],
        plugins: {
          multiupload: {
            apiUrl: process.env.VUE_APP_API_URL + '/file',
            authToken: `${this.authToken}`
          },
          fontsize: {
            sizeList: [
              '11px',
              '12px',
              '14px'
            ],
            allowCustomSize: true
          }
        }
        // https://alex-d.github.io/Trumbowyg/documentation
      },
    }
  },
  methods: {
    ...mapActions([
      'getSectionById',
      'storeSection',
      'deleteSection',
    ]),
    ...mapMutations([
      'clearSection'
    ])
  },
  mounted() {
    this.getSectionById(this.sectionId)
  },
  computed: {
    ...mapGetters([
      'getStoredSection'
    ]),
    section() {
      return this.getStoredSection
    }
  },
  beforeDestroy() {
    this.clearSection()
  }
}
</script>

<style scoped>

</style>
